import styled from "styled-components";

export const Styled = styled.div`
  background-color: white;
  margin-top: 10px;
  border: 5px double #abcff0;
  border-radius: 5px;
  height: 90px;
  font-size: 32px;
  padding: 10px;
  text-align: left;
  overflow: hidden;
  span {
    span {
      border-radius: 5px;
      background-color: white;
    }
  }

  @media (max-width: 540px) {
    height: 120px;
    font-size: 24px;
  }
`;
